export const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || ''));
export const isPin = (s) => /^\d{4}$/.test(String(s || ''));
export const isNonEmpty = (s) => String(s || '').trim().length > 0;
export const isUrl = (s) => {
  try { new URL(s); return true; } catch { return false; }
};
export const isPhoneLoose = (s) => /^[+]?[\d\s\-()]{7,}$/.test(String(s || ''));
// eslint-disable-next-line no-control-regex -- strip intencional de caracteres de control
export const sanitize = (s) => String(s || '').trim().replace(/[\x00-\x1f]/g, '');
